import { RcButton, styled } from '@ringcentral/juno';
import { useProximaNovaSemibold } from '@/core/sc';

export const StyledButton = styled(RcButton)`
  ${useProximaNovaSemibold};
  min-height: 40px;
`;
